import requestApi from "../common/boxp_api_client";


const getOilGraphDetails = (params) => {
    return requestApi({
        url: "/oil_accuracy_graph",
        method: "GET",
        params,
    })
}
const getOilTableDetails = (params) => {
    return requestApi({
        url: "/station_overview",
        method: "GET",
        params,
    })
}








export const StoreDashboardServices = {

    getOilGraphDetails,
    getOilTableDetails



}